module.exports = __webpack_public_path__ + "static/media/selection_paramountplus.1bcc6129.png";